import { eraseCookie, createCookie, readCookie } from '../../utils/Cookies';

export const SET_PARENTAL_LOCK = 'SET_PARENTAL_LOCK';
const COOKIE_EXPIRE_DAYS = 3652;
const COOKIE_NAME = 'parental-lock';

function saveParentalLock(newCode) {
    if (typeof window !== 'undefined') {
        if (!newCode) {
            eraseCookie(COOKIE_NAME);
        } else {
            createCookie(COOKIE_NAME, newCode, COOKIE_EXPIRE_DAYS);
        }
    }
}

export function setParentalLock(newCode) {
    saveParentalLock(newCode);

    return {
        type: SET_PARENTAL_LOCK,
        payload: newCode,
    };
}

export function fetchParentalLock() {
    return setParentalLock(readCookie('parental-lock'));
}
